export const SET_FILTERED_ITEMS = 'catalog:items:set';
export const SELECT_FACET = 'catalog:query:facet:select';
export const SELECT_MULTI_FACET = 'catalog:query:facet:select:multi';
export const UPDATE_FACETS = 'catalog:query:facets:update';
export const SET_PAGE_SIZE = 'catalog:query:pageSize:set';
export const SET_PAGE_SORT = 'catalog:query:sort:set';
export const CLEAR_FACET_VALUE = 'catalog:query:facet:clear';
